import { Box, Typography, useTheme } from "@mui/material"
import RedCloseIcon from "assets/icons/RedCloseIcon.svg"
import React, { useState } from "react"
import { Col, Row } from "react-bootstrap"
import StyledLabel from "components/StyledComponents/StyledLabel"
import { FieldArray } from "formik"
import AppTextField from "components/StyledComponents/AppTextField"
import { AddOutlined } from "@mui/icons-material"
import AppButton from "components/StyledComponents/AppButton"
import ImageUploadField from "components/FileUpload/ImageUploadField"
import { marketingActions } from "redux/marketing/slice/user"
import { useDispatch } from "react-redux"
import { uploadDidYouKnowImageAction } from "redux/marketing/actions/user"
import ImageCropper from "components/ImageCropper"

const DID_YOU_KNOW_IMAGE_TYPES = [
  "image/png",
  "image/jpeg",
  "image/jpg",
  "image/svg+xml",
  "image/gif",
  "image/webp"
]
// GIF/WebP are uploaded as-is (skip the cropper) so animation/format is preserved
const SKIP_CROP_TYPES = ["image/gif", "image/webp"]

const DidYouKnowFormHotel = ({ formik, values, name, buttonText, label }) => {
  const theme = useTheme()
  const dispatch = useDispatch()
  const [openCrop, setCrop] = useState(false)
  const [fileDetails, setFileDetails] = useState(null)
  const [imageObjectURL, setImageObjectUrl] = useState(null)
  const [imgIndex, setImgIndex] = useState()

  const onImageUpload = (image, index) => {
    setImgIndex(index)
    if (SKIP_CROP_TYPES.includes(image?.type)) {
      uploadImageFile(image, index, formik)
      return
    }
    setCrop(true)
    setFileDetails(image)
    setImageObjectUrl(URL.createObjectURL(image))
  }

  function uploadImageFile(image, index, formik) {
    let data = new FormData()
    data.append("media", image)
    data.append("media_type", "IMAGE")
    data.append("content_type", image.type)
    formik.setFieldValue("image", image)
    dispatch(uploadDidYouKnowImageAction({ index, data }))
    formik.setFieldValue(`${name}[${index}].image`, image)
    formik.setFieldTouched(`${name}[${index}].image`)
  }

  function handleCroppedImage(image, formik) {
    uploadImageFile(image, imgIndex, formik)
  }

  function showCropperModal(imageObjectURL, fileDetails, formik) {
    return (
      <ImageCropper
        setSelectedImage={(image) => handleCroppedImage(image, formik)}
        srcImage={imageObjectURL}
        fileDetail={fileDetails}
        aspectRatio={1}
        onClose={setCrop}
        openCrop={openCrop}></ImageCropper>
    )
  }

  const handleDeleteImage = (formik, index) => {
    dispatch(marketingActions.setDidYouKnowImage({ index, id: null }))
    formik.setFieldValue(`${name}[${index}].image`, null)
  }

  return (
    <div>
      {showCropperModal(imageObjectURL, fileDetails, formik)}
      <Box flexDirection="column">
        <Row className="w-100 m-0">
          <StyledLabel>{label}</StyledLabel>
          <FieldArray
            name={name}
            render={(arrayHelper) => (
              <>
                {values?.length
                  ? values?.map((did_you_know, index) => (
                      <>
                        <Col lg="12" className="align-items-center mt-4">
                          <Typography
                            variant="body1Regular"
                            sx={{
                              color: theme.palette.secondary.main,
                              textUnderlineOffset: "2px"
                            }}>
                            {`Card #${index + 1}`}
                          </Typography>
                        </Col>
                        <Row
                          className="mt-2"
                          style={{ paddingRight: 0 }}
                          id={`${name}-${index}`}
                          key={`${name}-${index}`}>
                          <Col lg="11">
                            <Col lg="12">
                              <AppTextField
                                id={`${name}[${index}].heading`}
                                name={`${name}[${index}].heading`}
                                label="Heading"
                                isUpperCase={true}
                                type="text"
                                fullWidth
                                placeholder={`Enter Heading`}
                                value={did_you_know?.heading || ""}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    `${name}[${index}].heading`,
                                    event.target.value
                                  )
                                }}
                                onBlur={formik.handleBlur(`${name}[${index}].heading`)}
                                error={Boolean(formik.errors?.[name]?.[index]?.heading)}
                                helperText={formik.errors?.[name]?.[index]?.heading}
                              />
                            </Col>
                            <Col lg="12" className="mt-4">
                              <AppTextField
                                id={`${name}[${index}].content`}
                                name={`${name}[${index}].content`}
                                label="Content"
                                isUpperCase={true}
                                type="text"
                                fullWidth
                                placeholder="Enter Content"
                                value={did_you_know?.content || ""}
                                onChange={(event) => {
                                  formik.setFieldValue(
                                    `${name}[${index}].content`,
                                    event.target.value
                                  )
                                }}
                              />
                            </Col>
                            <Col lg="12" className="mt-4">
                              <ImageUploadField
                                label={"Image"}
                                isVariant={true}
                                placeholder={`Upload Image`}
                                allowedTypes={DID_YOU_KNOW_IMAGE_TYPES}
                                value={did_you_know?.image || ""}
                                onChange={(e) => onImageUpload(e, index)}
                                onDelete={() => handleDeleteImage(formik, index)}
                              />
                            </Col>
                          </Col>
                          <Col
                            lg="1"
                            className="mt-4"
                            style={{ display: "flex", justifyContent: "center" }}>
                            {index > 0 && (
                              <span role="button" onClick={() => arrayHelper.remove(index)}>
                                <img
                                  className="flex-shrink-0"
                                  role="button"
                                  src={RedCloseIcon}
                                  alt="Delete"
                                  style={{ width: 30, marginTop: "20px", marginLeft: "10px" }}
                                />
                              </span>
                            )}
                          </Col>
                        </Row>
                      </>
                    ))
                  : null}
                <Row className="m-0 mt-5">
                  <AppButton
                    fullWidth
                    onClick={() =>
                      arrayHelper.push({
                        heading: "",
                        content: "",
                        image: ""
                      })
                    }
                    startIcon={<AddOutlined />}>
                    {buttonText}
                  </AppButton>
                </Row>
              </>
            )}
          />
        </Row>
      </Box>
    </div>
  )
}

export default DidYouKnowFormHotel
